import { render, staticRenderFns } from "./PackageComparisonTable.vue?vue&type=template&id=26d153b7&scoped=true&"
import script from "./PackageComparisonTable.vue?vue&type=script&lang=js&"
export * from "./PackageComparisonTable.vue?vue&type=script&lang=js&"
import style0 from "./PackageComparisonTable.vue?vue&type=style&index=0&id=26d153b7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d153b7",
  null
  
)

export default component.exports